module.exports = __webpack_public_path__ + "media/logos/accenture-8d206c1a.png";